/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, schemaMarkup }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description

  const commonSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "AES Electronic Services",
    "alternateName": "AES Inc",
    "url": "https://www.aesintl.com/",
    "sameAs": [
      "https://www.facebook.com/aesintl1992/",
      "https://twitter.com/AES_INC1992",
      "https://www.linkedin.com/company/aes---advanced-electronic-services-inc?_l=en_US",
      "https://www.youtube.com/channel/UCuZ9fYNg7lHPUM2An-ZHEzg"
    ]

  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title || `AES`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      {schemaMarkup ? (
        <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>
      ):(
        <script type="application/ld+json">{JSON.stringify(commonSchema)}</script>
      )}
      <script src="https://www.cognitoforms.com/f/iframe.js"></script>
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
